const initialState = {
  userDetails: null
}

export const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case "UPDATE_USER_DETAILS":
      return {
        ...state,
        ...action.data,
        // userDetails: action.data.userDetails,
        // user: action.data.user,
        // profileQuestions: action.data.profileQuestions,
        // homescreenData: action.data.homescreenData,
        // assessmentStatus: action.data.assessmentStatus,
      };
    case "UPDATE_QUESTION_ANSWERS":
      return {
        ...state,
        profileQuestions: action.questionsWithAnswers
      };
    default:
      return state;
  }
}
